export default __webpack_public_path__ + "static/fall11-d44bdae3cd307ea8a086b2bf04081fa5.webp";